(function () {
  if (customElements.get('ce-header-mobile-navigation') !== undefined) {
    return;
  }

  class HeaderMobileNavigation extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        dialog: 'ce-dialog',
        panelInner: '[data-header-mobile-navigation-panel-inner]',
        childMenus: 'ce-header-mobile-child-menu',
      };

      this.elements = null;

      this.handleDialogAttrIsOpen = this.handleDialogAttrIsOpen.bind(this);

      if (Shopify.designMode) {
        this.handleShopifyBlockSelect = this.handleShopifyBlockSelect.bind(this);
      }
    }

    get isOpen() {
      return this.getAttribute('is-open') === 'true';
    }

    set isOpen(value) {
      this.setAttribute('is-open', value);
    }

    get willTrapFocus() {
      return this.getAttribute('will-trap-focus') === 'true';
    }

    set willTrapFocus(value) {
      this.setAttribute('will-trap-focus', value);
    }

    static get observedAttributes() {
      return ['is-open', 'will-trap-focus'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-open':
          if (newValue !== null) {
            if (newValue === 'true') {
              this.willTrapFocus = true;
            } else {
              this.willTrapFocus = false;

              for (let childMenu of this.elements.childMenus) {
                if (typeof childMenu.close === 'function') {
                  childMenu.close();
                }
              }
            }
          }

          break;
        case 'will-trap-focus':
          if (newValue !== null) {
            for (let childMenu of this.elements.childMenus) {
              childMenu.willTrapFocus = newValue;
            }
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        dialog: this.closest(this.selectors.dialog),
        panelInner: this.querySelector(this.selectors.panelInner),
        childMenus: this.querySelectorAll(this.selectors.childMenus),
      };

      this.elements.dialog.addEventListener('ce-dialog:is-open', this.handleDialogAttrIsOpen);

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleShopifyBlockSelect);
      }

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.dialog.removeEventListener('ce-dialog:is-open', this.handleDialogAttrIsOpen);

      if (Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.handleShopifyBlockSelect);
      }
    }

    handleDialogAttrIsOpen(event) {
      const isOpen = event.detail;
      this.isOpen = isOpen;
    }

    handleShopifyBlockSelect(event) {
      if (event.detail.sectionId !== 'header') {
        return;
      }

      if (!Themu.isViewportDesktop) {
        this.elements.dialog.shopifyDesignModeOpen();

        this.elements.panelInner.scrollTo({
          left: 0,
          top: event.target.offsetTop,
          behavior: Themu.prefersReducedMotion ? 'instant' : 'smooth',
        });
      }
    }
  }

  customElements.define('ce-header-mobile-navigation', HeaderMobileNavigation);
})();
